export const primaryColors = {
  paleGreen: "#5ac1d2",
  violet: "#974b97",
};
